import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'I have zero experience. Can I really start?',
  answer: 'Yes. The vast majority of Storm students start with zero martial arts experience. Beginner classes are designed specifically for first-timers — kids and adults alike.'
}, {
  question: 'What age can I start?',
  answer: 'Storm teaches ages 3 and up. Mini Troopers is for ages 3–5, Kids Taekwondo (Storm Troopers) is for ages 6+, and adult classes are open to teens through grandparents.'
}, {
  question: 'Is Storm a karate school?',
  answer: 'No, Storm teaches Taekwondo — Olympic-style, WT / Kukkiwon aligned. Many people search "karate" as a catch-all term for martial arts; the confidence, discipline, fitness, and self-defense benefits are the same.'
}, {
  question: 'Do I need a uniform or gear to start?',
  answer: 'No. Wear comfortable athletic clothing for your trial class — t-shirt and sweatpants or leggings, bare feet on the mat. Uniform options are explained if you decide to continue.'
}, {
  question: 'How do I pick the right starting class?',
  answer: "Tell us your age (or your child's age), goals, and schedule on the form, or call 517-220-0621. A Storm coach will recommend the best starting class before your first visit."
}, {
  question: 'Where is Storm located?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335 — easy to reach from Novi, Commerce, Walled Lake, Wixom, Livonia, Northville, Waterford and other Southeast Michigan communities.'
}];
export function DoSomeMartialArtsFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-935" />;
}